import React, { useContext, useEffect } from 'react';
import useCollapse from 'react-collapsed';
import './TabAppealAnswerCollapse.scss';
import { Typography } from 'antd';
import {
  formatDate,
  formatHtmlString,
  getAnswerStatusText,
} from '../../../utils/formatter';
import { AppealAnswer } from '../../../model/AppealAnswer';
import TabAppealAnswerRow from '../TabAppealAnswerRow/TabAppealAnswerRow';
import { useAppeal } from '../../../context/appeal/AppealContext';
import { Context } from '../../../index';
import Constants from '../../../constants/constants';

interface TabAppealAnswerCollapseProps {
  appealId: number;
  appealAnswer: AppealAnswer;
}

const TabAppealAnswerCollapse = (
  props: TabAppealAnswerCollapseProps
): JSX.Element => {
  const [renderChildren, setRenderChildren] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [appealAnswer, setAppealAnswer] = React.useState<AppealAnswer>(
    props.appealAnswer
  );
  const { store } = useContext(Context);
  const { refreshAnswer, removeRefreshedAnswer } = useAppeal();

  const { getToggleProps, getCollapseProps, isExpanded } = useCollapse({
    defaultExpanded: false,
    onExpandStart() {
      setRenderChildren(true);
    },
    onCollapseEnd() {
      setRenderChildren(false);
    },
    isExpanded: expanded,
  });

  useEffect(() => {
    if (
      refreshAnswer.length > 0 &&
      refreshAnswer.includes(props.appealAnswer.id)
    ) {
      store.getAppealAnswer(props.appealAnswer.id).then((resp) => {
        if (resp) {
          setAppealAnswer(resp);
          removeRefreshedAnswer(resp.id);
        }
      });
    }
  }, [refreshAnswer]);

  return (
    <div
      className={`tabAppealAnswerCollapse ${isExpanded ? 'openContent' : ''}`}
    >
      <div className="tabAppealAnswerCollapse__header">
        <div className="tabAppealAnswerCollapse__message-title">
          {formatHtmlString(appealAnswer.executorText)}
        </div>
        <div className="tabAppealAnswerCollapse__status">
          <div
            className={`statusRound statusRound-${
              appealAnswer.holdTo && appealAnswer.isSolved
                ? Constants.statusCodeHold
                : appealAnswer.isSolved
            }`}
          />
          <Typography.Paragraph>
            {getAnswerStatusText(appealAnswer.holdTo, appealAnswer.isSolved)}
          </Typography.Paragraph>
        </div>
        <div className="tabAppealAnswerCollapse__date">
          <Typography.Paragraph>
            {formatDate(appealAnswer.createdAt)}
          </Typography.Paragraph>
        </div>
        <div className="tabAppealAnswerCollapse__info">
          <button {...getToggleProps()} onClick={() => setExpanded(!expanded)}>
            {isExpanded ? 'Свернуть' : 'Подробнее'}
          </button>
          <div {...getToggleProps({})} onClick={() => setExpanded(!expanded)}>
            {isExpanded}
          </div>
        </div>
      </div>
      <div
        className="tabAppealAnswerCollapse__content"
        {...getCollapseProps({})}
      >
        {renderChildren && (
          <div className="tabAppealAnswerCollapse__box">
            <TabAppealAnswerRow
              appealId={props.appealId}
              appealAnswer={appealAnswer}
              setExpanded={setExpanded}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TabAppealAnswerCollapse;
